import { MultiSelect } from '@mantine/core'
import MultiSelectClasses from './styles.module.css'
import '../../styles/variables.css'

export default MultiSelect.extend({
    defaultProps: { radius: 'lg', size: 'lg' },
    classNames: MultiSelectClasses,
})
